import { render, staticRenderFns } from "./DialogModel.vue?vue&type=template&id=23ab79a1&"
import script from "./DialogModel.vue?vue&type=script&lang=js&"
export * from "./DialogModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports